import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import _get from "lodash/get";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tracking } from '@nerdwallet/nw-client-lib';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'; // Components

import ProductOverview from '../product-overview/product-overview';
import ProductDetails from '../product-details/product-details';
import ProductDetailsToggle from '../product-details-toggle/product-details-toggle';
var formOpen = Tracking.formOpen,
    formCancel = Tracking.formCancel;

var ProductRow =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductRow, _Component);

  function ProductRow(props) {
    var _this;

    _classCallCheck(this, ProductRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductRow).call(this, props));
    _this.state = {
      isExpanded: false
    };
    _this.toggleExpanded = _this.toggleExpanded.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.scrollIntoView = _this.scrollIntoView.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ProductRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.exposeToggleToWindow();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.isExpanded !== nextState.isExpanded || this.props.data !== nextProps.data;
    }
  }, {
    key: "exposeToggleToWindow",
    value: function exposeToggleToWindow() {
      if (typeof window !== 'undefined') {
        window.rowOpeners = window.rowOpeners || [];
        window.rowOpeners.push(this.toggleExpanded);
      }
    }
  }, {
    key: "toggleExpanded",
    value: function toggleExpanded() {
      var curState = this.state.isExpanded;
      this.setState({
        isExpanded: !curState
      });
      var trackingData = {
        formName: this.props.tableName,
        fieldName: this.props.viewConfig.trackingFieldName || 'broker',
        fieldValue: _get(this.props.data, this.props.viewConfig.productNameKey)
      };

      if (curState) {
        this.scrollIntoView();
        formCancel(trackingData);
      } else {
        formOpen(trackingData);
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      // `animatedScrollTo` only executes on client side
      // If you remove this require, also remove dependency note up top
      var animatedScrollTo = require('animated-scrollto'); // eslint-disable-line


      var headerHeight = 70;
      var productElement = this.productElement;
      var cardOffsetTop = productElement.getBoundingClientRect().top;
      var y = cardOffsetTop + window.pageYOffset - headerHeight;
      animatedScrollTo(document.body, y, 300);
      animatedScrollTo(document.documentElement, y, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var columnSize = this.props.viewConfig.columns.length;
      var _this$props = this.props,
          analytics = _this$props.analytics,
          customComponents = _this$props.customComponents,
          data = _this$props.data,
          detailsComponent = _this$props.detailsComponent,
          mustClickToggleForDrawer = _this$props.mustClickToggleForDrawer,
          viewConfig = _this$props.viewConfig,
          productIndex = _this$props.productIndex;
      var details;

      if (this.state.isExpanded) {
        var DetailsComponent = detailsComponent || ProductDetails;
        details = React.createElement(DetailsComponent, this.props);
      }

      return React.createElement("tbody", {
        ref: function ref(c) {
          _this2.productElement = c;
        },
        className: "product ".concat(this.state.isExpanded === true ? 'expanded' : '')
      }, React.createElement(ProductOverview, {
        productIndex: productIndex,
        analytics: analytics,
        viewConfig: viewConfig.columns,
        data: data,
        toggleExpanded: this.toggleExpanded,
        isExpanded: this.state.isExpanded,
        customComponents: customComponents,
        customToggleText: viewConfig.customToggleText,
        mustClickToggleForDrawer: mustClickToggleForDrawer
      }), React.createElement("tr", null, React.createElement("td", {
        colSpan: columnSize
      }, React.createElement(CSSTransitionGroup, {
        ref: function ref(c) {
          _this2.ProductRow = c;
        },
        transitionName: "product-details",
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300
      }, details))), React.createElement("tr", {
        className: "toggle-expanded-after-product"
      }, React.createElement("td", {
        colSpan: columnSize
      }, React.createElement(ProductDetailsToggle, {
        analytics: _get(analytics, 'detailsDrawer'),
        onClick: this.toggleExpanded,
        isExpanded: this.state.isExpanded,
        customToggleText: viewConfig.customToggleText
      }))));
    }
  }]);

  return ProductRow;
}(Component);

ProductRow.displayName = 'ProductRow';
ProductRow.propTypes = {
  analytics: PropTypes.shape({
    productTable: PropTypes.shape({
      pageNumber: PropTypes.number,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),
    productTableAllOffers: PropTypes.shape({
      entityName: PropTypes.string,
      elementPosition: PropTypes.number,
      parentImpressionId: PropTypes.string,
      productType: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),
    detailsDrawer: PropTypes.shape({
      entityName: PropTypes.string
    })
  }),
  productIndex: PropTypes.number,
  tableName: PropTypes.string,
  trackingFieldName: PropTypes.string,
  viewConfig: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  data: PropTypes.object,
  customComponents: PropTypes.object,
  reviewTarget: PropTypes.string,
  detailsComponent: PropTypes.func,
  mustClickToggleForDrawer: PropTypes.bool
};
export default ProductRow;